import React from "react";
import "./ShareProfileButton.css"; // default styling
import { Shareicon } from "../../lib/myIcons";

const ShareProfileButton = ({ 
  userObject, 
  isLocalHost,
  buttonText = "Share Profile", 
  className = "", 
  disabled = false 
}) => {

  // console.log("userObject in ShareProfileButton: ",userObject);
  
  const handleShareProfile = async (e) => {
    // console.log("handleShareProfile called");
    e.preventDefault();

    if (!userObject?.id) return;

    // console.log("Sharing profile for user:", userObject);

    // const isLocalhost = window.location.hostname === "localhost";
    const shareUrl = isLocalHost
      ? `${import.meta.env.VITE_DSERVER_BASEURL}/api/users/shareprofile/${userObject.id}`
      : `${import.meta.env.VITE_SH_DSERVER_BASEURL}/api/users/shareprofile/${userObject.id}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: `${userObject.username}'s Profile`,
          text: `Check out ${userObject.username}'s profile on our platform!`,
          url: shareUrl,
        });
        console.log("Profile shared successfully!");
      } catch (error) {
        console.error("Profile sharing failed:", error);
      }
    } else {
      // fallback: copy URL to clipboard
      try {
        await navigator.clipboard.writeText(shareUrl);
        alert("Share link copied to clipboard!");
      } catch {
        alert("Sharing not supported and failed to copy link 😕");
      }
    }
  };

  return (
    <button
      type="button"
      className={`shareButton ${className}`}
      onClick={handleShareProfile}
      disabled={disabled || !userObject?.id}
    >
              <Shareicon
                color="white"
                >

              </Shareicon>



      {buttonText}
    </button>
  );
};

export default ShareProfileButton;
